import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule, RouterOutlet } from '@angular/router';
import { BrowserUtilService } from '@app/core/services';
import { nl } from '@app/core/translations';
import { UserAvatar } from './shared';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    UserAvatar,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  readonly browserUtils = inject(BrowserUtilService);
  readonly t = nl.nav;

  closeSideNavIfHandset(sideNav: MatSidenav) {
    if (this.browserUtils.isHandset()) {
      sideNav.close();
    }
  }
}
